document.addEventListener("DOMContentLoaded", async () => {
  if (window.Shopify && window.Shopify.country) {
    const storedMarket = localStorage.getItem("current_market");
    const currentMarket = window.Shopify.country;
    // console.log("storedMarket", storedMarket);
    // console.log("currentMarket", currentMarket);

    if (currentMarket && storedMarket !== currentMarket) {
      // console.log("Detected a change in market:", currentMarket);
      localStorage.setItem("current_market", currentMarket);

      try {
        await fetch("/cart/clear.js");
        const sideCart = document.querySelector("side-cart");
        const response = await fetch(window.Shopify.routes.root + "cart.js");
        const data = await response.json();
        await sideCart.reRenderCart(data);
      } catch (error) {
        console.error("Failed to clear cart:", error);
      }
    }
  } else {
    console.error("Shopify object or country property is not available.");
  }
});
